import { setBarChartSettings, setHeatmapChartSettings, setTableChartSettings, setBubbleChartSettings, setLineChartSettings, setGaugeChartSettings, setFunnelChartSettings, setChoroplethChartSettings, setMetricChartSettings, } from './chart-settings';
export var createChartSettings = function (_a) {
    var query = _a.query, widgetType = _a.widgetType, keys = _a.keys, componentSettings = _a.componentSettings;
    var input = { query: query, keys: keys, componentSettings: componentSettings };
    switch (widgetType) {
        case 'funnel':
            return setFunnelChartSettings(input);
        case 'gauge':
            return setGaugeChartSettings(input);
        case 'choropleth':
            return setChoroplethChartSettings(input);
        case 'bubble':
            return setBubbleChartSettings(input);
        case 'line':
        case 'area':
            return setLineChartSettings(input);
        case 'heatmap':
            return setHeatmapChartSettings(input);
        case 'bar':
            return setBarChartSettings(input);
        case 'table':
            return setTableChartSettings(input);
        case 'metric':
            return setMetricChartSettings(input);
        default:
            return {};
    }
};
